import axios from "axios";
import { FETCH_INSURANCE_TYPES_FAILURE, FETCH_INSURANCE_TYPES_REQUEST, FETCH_INSURANCE_TYPES_SUCCESS, FETCH_INSURANCE_TYPES_SUCCESS_2, FETCH_INSURANCE_TYPE_FAILURE, FETCH_INSURANCE_TYPE_REQUEST, FETCH_INSURANCE_TYPE_SUCCESS, } from "../../app/actions/actions";
import { ROUTES } from "../../config/routingUrl";
import { dureeDeVie, setWithExpiration } from "../../utils/storage/localvalueFuction";
import { localStorageData, localStorageKeys } from "../../utils/storage/localvalue";
import { baseurl } from "../../utils/url/baseurl";
import { saveDataToFile } from "../DataLocal";
import { toast } from "react-toastify";



// Create InssuranceType
export const InssuranceTypeCreate = (
    data) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_INSURANCE_TYPE_REQUEST });
        await axios
            .post(
                `${baseurl.url}/api/v1/insurance-types/`,
                data,
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success(response?.data?.message || "catégorie d'assurance créer avec succès", { position: "bottom-right" });
                dispatch({ type: FETCH_INSURANCE_TYPE_SUCCESS });
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "catégorie d'assurance non créer", { position: "bottom-right" });
                dispatch({ type: FETCH_INSURANCE_TYPE_FAILURE, payload: error.message });
            });
    };
}



// update insurance 
export const InssuranceTypeUpdateById = (idInssuranceType, data) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_INSURANCE_TYPE_REQUEST });
        await axios
            .put(`${baseurl.url}/api/v1/insurance-types/update/${idInssuranceType}`, data, {
                headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                }
            })
            .then((response) => {
                dispatch({ type: FETCH_INSURANCE_TYPE_SUCCESS });
                toast.success(response?.data?.message || "catégorie d'assurance mis à jour", { position: "bottom-right" });
                dispatch(fetchInssuranceTypesAll());

            })
            .catch((error) => {
                dispatch({ type: FETCH_INSURANCE_TYPE_FAILURE, payload: error.message });
                toast.error(error?.response?.data?.message || "catégorie d'assurance non mis à jour", { position: "bottom-right" });
                dispatch(fetchInssuranceTypesAll());

            });
    };
}





// All insurance of plateforme
export function fetchInssuranceTypesAll() {
    return async (dispatch) => {
        dispatch({ type: FETCH_INSURANCE_TYPES_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/insurance-types/get_insurance-types`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_INSURANCE_TYPES_SUCCESS, payload: response.data.data });
            dispatch({ type: FETCH_INSURANCE_TYPES_SUCCESS_2, payload: response.data.data });
            saveDataToFile(response.data.data, localStorageData.InssuranceTypes);
        })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_INSURANCE_TYPES_FAILURE, payload: error.message });
            });
    }
}


// get insurance by id 
export function fetchInssuranceTypeById(idInssuranceType) {
    return async (dispatch) => {
        dispatch({ type: FETCH_INSURANCE_TYPE_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/insurance-types/get_insurance-type/${idInssuranceType}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_INSURANCE_TYPE_SUCCESS, payload: response.data.data });
        })
            .catch((error) => {
                dispatch({ type: FETCH_INSURANCE_TYPE_FAILURE, payload: error.message })
                //console.log(error);
            });
    }
}

